import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  InputAdornment,
  MenuItem,
  Typography,
} from "@mui/material";
import IosShareOutlinedIcon from "@mui/icons-material/IosShareOutlined";
import React, { useCallback, useEffect, useState } from "react";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useLocation } from "react-router-dom";
import functions from "../../../utils/Api";
import moment from "moment";
import * as XLSX from "xlsx";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import CustomBarChart from "../../../components/CustomBarChart";
import { useDispatch, useSelector } from "react-redux";
import {
  setCustomMonthUser,
  setCustomMonthVendor,
} from "../../../Redux/reportSlice";
import CustomDatePickerDialog from "../../../components/CustomDatePickerDialog/CustomDatePickerDialog";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import dayjs from "dayjs";
import { TextField } from "@mui/material";
import "./VendorDetails.css";

const VendorDetails = () => {
  const location = useLocation();
  let id = location.pathname.split("/")[3];
  const dispatcher = useDispatch();

  const { customMonthVendor } = useSelector((state) => state.report);

  const [vendorDetailsById, setVendorDetailsById] = useState(null);
  const [mealDetails, setMealDetails] = useState(null);
  const [datePickerStatus, setDatePickerStatus] = useState(false);
  const [vendorDetailsData, setVendorDetailsData] = useState(null);
  const [mealTypeId, setMealTypeId] = useState("1");
  const [customDate, setCustomDate] = useState(
    customMonthVendor ? customMonthVendor : null
  );
  const [disableBtnLoading, setdisableBtnLoading] = useState(false);
  const [isloading, setIsloading] = useState(true);

  const breadCrumbData = [
    {
      label: "Home",
      path: "/cms/dashboard",
    },
    {
      label: "Users List",
      path: "/cms/users-list",
    },
  ];

  const mealDetailsJson = useCallback((data) => {
    data && data.sort((a, b) => new Date(a.mealDate) - new Date(b.mealDate));
    const categories = data
      ? data.map((item) => moment(item.mealDate).format("MMM D, YY"))
      : [];
    const guestsData = data
      ? data?.flatMap((item) =>
          item.details
            .filter((type) => type.mealType === "guest")
            .map((item) => item.mealCount)
        )
      : [];
    const selfData = data
      ? data?.flatMap((item) =>
          item.details
            .filter((type) => type.mealType === "self")
            .map((item) => item.mealCount)
        )
      : [];
    const contractData = data
      ? data.flatMap((item) =>
          item.details
            .filter((type) => type.mealType === "ctr-self")
            .map((item) => item.mealCount)
        )
      : [];
    setMealDetails({
      series: [
        { name: "Self", data: selfData },
        { name: "Guests", data: guestsData },
        { name: "Contract", data: contractData },
      ],
      categories,
    });
  }, []);

  const handleDate = useCallback(() => {
    let startDate = customDate.startOf("month").format("YYYY-MM-DD");
    let endDate = customDate.endOf("month").format("YYYY-MM-DD");
    return { startDate, endDate };
  }, [customDate]);

  useEffect(() => {
    if (vendorDetailsData && customDate) {
      let { startDate, endDate } = handleDate();
      async function getUserMealData() {
        let url = `/reports?mealTypeId=${mealTypeId}&locationId=${vendorDetailsData?.vendorLocationId}&startDate=${startDate}&endDate=${endDate}&vendorId=${vendorDetailsData?.vendorId}`;
        await functions
          .get(url)
          .then((res) => {
            mealDetailsJson(res?.data);
            setDatePickerStatus(false);
            setdisableBtnLoading(false);
            setIsloading(false);
          })
          .catch((err) => {
            console.log(err);
            setIsloading(false);
          });
      }
      getUserMealData();
    }
  }, [mealDetailsJson, mealTypeId, vendorDetailsData, customDate, handleDate]);

  useEffect(() => {
    if (id) {
      async function fetchVendorData() {
        try {
          await functions
            .get(`/vendor/${id}`)
            .then((res) => {
              if (res) {
                let details = {
                  "Vendor Name": res.data.vendorName,
                  Email: res.data.vendorEmail ?? "_",
                  "Vendor Location": res?.data["Location.displayName"] ?? "_",
                  "Phone Number": res.data.vendorPhone ?? "_",
                  avatar: res.data.profileImage ?? "_",
                };
                setVendorDetailsData(res?.data);
                setVendorDetailsById(details);
              }
            })
            .catch((err) => console.log(err));
        } catch (error) {
          console.log(error);
          // setIsloading(false);
        }
      }
      fetchVendorData();
    }
  }, [id]);

  const handleExport = () => {
    const headers = [
      "Vendor Name",
      "Vendor Email",
      "Vendor Location",
      "Vendor PhoneNumber",
      "Meal Type",
      "OrderedDate",
      "Self",
      "Guests",
      "Total Meal",
    ];
    const rows = mealDetails.categories.map((date, index) => {
      const self = mealDetails.series[0]?.data[index] || 0;
      const guest = mealDetails.series[1]?.data[index] || 0;
      return {
        "Vendor Name": vendorDetailsById.vendorName,
        "Vendor Email": vendorDetailsById.email,
        "Vendor Location": vendorDetailsById.vendorLocation,
        "Vendor PhoneNumber": vendorDetailsById["Phone Number"],
        "Meal Type": mealTypeId === "1" ? "Breakfast" : "Dinner",
        OrderedDate: date,
        Self: self,
        Guests: guest,
        "Total Meal": Number(self) + Number(guest),
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
    XLSX.writeFile(
      workbook,
      `${vendorDetailsById?.vendorName}-Report-${
        mealTypeId === "1" ? "Breakfast" : "Dinner"
      }-${moment(customMonthVendor).format("MMMM,YYYY")}.xlsx`
    );
  };

  const handleCustomDateRange = () => {
    setDatePickerStatus(true);
  };

  const handleCustomMonthChange = (month) => {
    dispatcher(setCustomMonthVendor(month));
  };

  const handleDateRangePicker = () => {
    setDatePickerStatus(false);
    dispatcher(setCustomMonthUser(dayjs()));
  };

  const handleMealTypeChange = (e) => {
    setIsloading(true);
    setMealTypeId(e.target.value);
  };

  const handleSubmitDateRange = (e) => {
    e.preventDefault();
    setdisableBtnLoading(true);
    setCustomDate(customMonthVendor);
  };

  return (
    <div className="userDetials">
      <Box className="userDetails-breadcrumb">
        <CustomBreadcrumbs
          items={breadCrumbData}
          currentLabel="Vendor Details"
        />
      </Box>
      {!isloading ? (
        <Box className="userDetails-main">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              margin: "10px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Avatar
                sx={{
                  width: "50px",
                  height: "50px",
                  // margin: "0px 10px 20px 0px",
                  backgroundColor: "#004D72",
                }}
              ></Avatar>
              <Box sx={{ display: "flex" }}>
                <Typography>
                  <MailOutlineIcon />
                </Typography>
                <Typography ml={1}>{vendorDetailsById?.Email}</Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex" }}>
              <Box marginRight="20px">
                <TextField
                  size="small"
                  sx={{ width: "170px" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <VolunteerActivismOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  select
                  value={mealTypeId}
                  variant="outlined"
                  onChange={handleMealTypeChange}
                >
                  <MenuItem value={1}>Breakfast</MenuItem>
                  <MenuItem value={2}>Dinner</MenuItem>
                  {/* <MenuItem value={3}>Lunch</MenuItem> */}
                </TextField>
              </Box>
              <Button
                variant="contained"
                startIcon={<DateRangeOutlinedIcon />}
                sx={{
                  borderColor: "#004D72",
                  color: "#FFFFFF",
                }}
                onClick={handleCustomDateRange}
              >
                {dayjs(customDate).format("MMMM, YYYY")}
              </Button>
              <Button
                variant="outlined"
                startIcon={<IosShareOutlinedIcon />}
                sx={{
                  borderColor: "#C1C1C2",
                  color: "black",
                  marginLeft: "20px",
                  "&:hover": { borderColor: "#C1C1C2" },
                }}
                onClick={handleExport}
              >
                Export
              </Button>
            </Box>
          </Box>
          <Divider sx={{ marginBottom: "10px" }} />
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <Box>
                <Grid container spacing={1}>
                  {vendorDetailsById !== null &&
                    Object.entries(vendorDetailsById).map(([key, value], i) => {
                      return (
                        <React.Fragment key={i}>
                          <Grid item xs={12}>
                            <Typography
                              mb={4}
                              className={`${
                                key === "Email" || key === "avatar"
                                  ? "hideEmailTag"
                                  : key === "Vendor Name" ||
                                    key === "Vendor Location"
                                  ? "transformText"
                                  : ""
                              }`}
                              sx={{ mb: "10px" }}
                            >
                              <b>{key}</b> : <span>{value}</span>
                            </Typography>
                          </Grid>
                        </React.Fragment>
                      );
                    })}
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <Box>
                <CustomBarChart
                  chartData={{
                    series: [
                      {
                        name: "Self",
                        label: "Self",
                        data: mealDetails?.series[0]?.data,
                        color: "#1E88E5",
                        stack: "total",
                      },
                      {
                        name: "Guests",
                        label: "Guest",
                        data: mealDetails?.series[1]?.data,
                        color: "#A5D6A7",
                        stack: "total",
                      },
                      {
                        name: "Contract",
                        label: "Contract",
                        data: mealDetails?.series[1]?.data,
                        color: "#EEA53E",
                        stack: "total",
                      },
                    ],
                    categories: mealDetails?.categories,
                  }}
                  barWidth={60}
                  categoryGapRatio={0.4}
                  //   onBarClick={handleBarClick}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      )}
      {datePickerStatus && (
        <CustomDatePickerDialog
          value={customMonthVendor}
          handleCustomMonthChange={handleCustomMonthChange}
          open={datePickerStatus}
          handleDateRangePicker={handleDateRangePicker}
          handleSubmit={handleSubmitDateRange}
          disableBtnLoading={disableBtnLoading}
        />
      )}
    </div>
  );
};

export default VendorDetails;
